<template>
    <form-row>
        <div class="flex flex-col flex-1">
            <div class="w-full">
                <tenant-details
                    v-for="tenant in tenants"
                    :key="tenant.id"
                    :read_only="read_only"
                    :tenant="tenant"
                    :property="property"
                    @deleteTenant="deleteTenant"
                />
            </div>

            <div class="flex justify-end">
                <button v-if="! read_only"
                    type="button"
                    class="flex items-center uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none"
                >
                    <span class="text-xl font-bold mr-2">+</span>

                    <span class="inline-block font-semibold text-sm py-2 cursor-pointer select-none"
                        @click="addTenant"
                    >
                        {{ $t('Add tenant') }}
                    </span>
                </button>
            </div>
        </div>
    </form-row>
</template>

<script>
import TenantDetails from './tenant-details.vue';

export default {
    components: {
        TenantDetails,
    },

    props: {
        read_only: { default: false },
        property: {},
    },

    computed: {
        tenants() {
            return store.state.commercial_tenants;
        },
    },

    methods: {
        addTenant() {
            axios.post('/broker/properties/' + this.property.id + '/deal/commercial/tenant')
                .then(response => {
                    console.log(response.data);
                    store.state.commercial_tenants.push(response.data);
                }).catch(error => {
                    console.log(error.response);
                });
        },
        deleteTenant(id) {
            axios.delete('/broker/properties/' + this.property.id + '/deal/commercial/tenant/' + id)
                .then(response => {
                    let index = this.findTenantIndexById(id);

                    if (index > -1) {
                        store.state.commercial_tenants.splice(index, 1);
                    }
                }).catch(error => {
                    console.log(error.response);
                });
        },
        findTenantIndexById(id) {
            return store.state.commercial_tenants.findIndex(tenant => tenant.id === id);
        },
    },
}
</script>
